import { createAction, props } from '@ngrx/store'

export const start_logout = createAction('start_logout', props<any>())
export const logout_success = createAction('logout_success', props<{ data: any }>())
export const logout_failed = createAction('logout_failed', props<{ data: any }>())
